import React from 'react';

import InlineAlert from 'app/commonComponents/InlineAlert';

interface FormErrorProps {
  message: string;
  style?: React.CSSProperties;
}

function FormError({ message, style, ...rest }: FormErrorProps) {
  return (
    <InlineAlert
      type="error"
      style={{ marginBottom: '1rem', ...style }}
      {...rest}
    >
      {message}
    </InlineAlert>
  );
}

export default FormError;
